export default defineNuxtPlugin(() => {
  useHead({
    script: [
      {
        'src': 'https://view.publitas.com/ecommTracker.js',
        'data-url': 'https://view.publitas.com/ecomm-tracker',
        'data-usercentrics': 'Publitas',
        'type': 'text/plain',
      },
    ],
  });
});
